<template>
  <!-- Footer Start  -->
  <div class="section footer-section">

    <!-- Footer Widget Section Start -->
    <div class="footer-widget-section">

      <img class="shape-1 animation-down" src="/assets/images/shape/shape-21.png" alt="Shape">

      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 order-md-1 order-lg-1">

            <!-- Footer Widget Start -->
            <div class="footer-widget">
              <div class="widget-logo">
                <a href="#"><img src="/assets/images/logo.png" alt="Logo"></a>
              </div>

              <div class="widget-address">
                <h4 class="footer-widget-title">Jupiter Maritime Ltd.</h4>
                <p>47 Knoll Drive, London, England, N14 5LU</p>
              </div>

              <ul class="widget-info">
                <li>
                  <p> <i class="flaticon-email"></i> <a href="mailto:support@thecolregs.com">{{support_email}}</a> </p>
                </li>
              </ul>
            </div>
            <!-- Footer Widget End -->

          </div>
          <div class="col-lg-5 order-md-3 order-lg-2">

            <!-- Footer Widget Link Start -->
            <div class="footer-widget-link">

              <!-- Footer Widget Start -->
              <div class="footer-widget">
                <h4 class="footer-widget-title">Category</h4>

                <ul class="widget-link">
                  <li><router-link to="/">Home</router-link></li>
                  <li><router-link to="/about">About Us</router-link></li>
                  <li><router-link to="/packages">Packages</router-link></li>
                  <li><router-link to="/contact">Contact Us</router-link></li>
                </ul>

              </div>
              <!-- Footer Widget End -->

              <!-- Footer Widget Start -->
              <div class="footer-widget">
                <h4 class="footer-widget-title">Quick Links</h4>

                <ul class="widget-link">
                  <li><router-link to="/faq">FAQ</router-link></li>
                  <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
                  <li><router-link to="/TermsOfUse">Terms of Use</router-link></li>
                  <li><router-link to="/contact">Customer Support</router-link></li>
                </ul>

              </div>
              <!-- Footer Widget End -->

            </div>
            <!-- Footer Widget Link End -->

          </div>
          <div class="col-lg-3 col-md-6 order-md-2 order-lg-3">

            <!-- Footer Widget Start -->
            <div class="footer-widget">
              <h4 class="footer-widget-title">Subscribe</h4>

              <div class="widget-subscribe">
                <p>Subscribe for the latest updates, tips, and exclusive offers on MCQ exam prep.</p>

                <div class="widget-form">
                  <form  @submit.prevent="subscribe">
                    <input v-model="email" type="email" required placeholder="Email here">
                    <button class="btn btn-primary btn-hover-dark" type="submit">Subscribe Now
                      <div v-if='loader' class="loader"></div>
                    </button>
                    <p v-if="message" class="message">{{ message }}</p>
                  </form>
                </div>
              </div>
            </div>
            <!-- Footer Widget End -->

          </div>
        </div>
      </div>

      <img class="shape-2 animation-left" src="/assets/images/shape/shape-22.png" alt="Shape">

    </div>
    <!-- Footer Widget Section End -->

    <!-- Footer Copyright Start -->
    <div class="footer-copyright">
      <div class="container">

        <!-- Footer Copyright Start -->
        <div class="copyright-wrapper">
          <div class="copyright-text footer-align-center">
            <p>&copy; 2025 <span> COLREGs </span> Developed by <a href="https://www.flyingcoloursconsultancy.com" target="_blank" rel="noopener noreferrer nofollow">Flying Colours Consultancy</a></p>
          </div>
        </div>
        <!-- Footer Copyright End -->

      </div>
    </div>
    <!-- Footer Copyright End -->

  </div>
  <!-- Footer End -->

  <!--Back To Start-->
  <a href="#" class="back-to-top">
    <i class="icofont-simple-up"></i>

  </a>
  <!--Back To End-->
</template>

<script>
import {AppConfig} from '@/constants';
import {email_subscribe} from '@/services/emailSubService';
export default {
  name: "Footer",
  data(){
    return{
      support_email: null,
      email: null,
      message: null,
      loader: false
    }
  },
  mounted(){
    this.support_email = AppConfig.SUPPORT_EMAIL;
  },
  methods: {
    loadScript(src) {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    },

    async subscribe() {
      this.loader = true;
      try {
        this.message = await email_subscribe(this.email);
        this.email = "";
      } catch (err) {
        this.message = err.response?.data?.error || "Something went wrong";
      } finally {
        this.loader = false;
      }
    }
  },
};
</script>
<style scoped>
button .loader {
  display: inline-block;
  margin-left: 8px; /* optional spacing between span and loader */
  vertical-align: middle;
}

.loader {
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 4px solid white;
  border-right-color: #309255;
  animation: l2 1s infinite linear;
}
@keyframes l2 {to{transform: rotate(1turn)}}

form p.message {
  background-color: #D4F1D4;
  color: #0A3B20; 
  padding: 12px 16px;
  margin-top: 12px;
  border-radius: 6px;
  font-size: 0.95rem;
  text-align: center;
}
</style>